export const PRESCRIPTION_DATA_QUEUE= "PRESCRIPTION_DATA_QUEUE"
export const SYSTEM_ONLINE= "SYSTEM_ONLINE"
export const PRESCRIPTION_DATA_PEEK_DEQUEUE= "PRESCRIPTION_DATA_PEEK_DEQUEUE"
export const DRUG_TYPE= "DRUG_TYPE"
export const DRUG_NAME= "DRUG_NAME"
export const DIAGNOSIS_NAME= "DIAGNOSIS_NAME"